import { Hint, Input } from '@tecsinapse/cortex-react'
import React from 'react'
import { ErrorMessage } from '@hookform/error-message'
import { useController, useFormContext } from 'react-hook-form'

interface FormTextFieldProps {
  name: string
  label?: string
  customOnBlur?: (e: React.FocusEvent<HTMLDivElement, Element>) => void
  disabled?: boolean
  type?: string
}

export const FormTextField = ({
  name,
  label,
  customOnBlur,
  disabled,
  type
}: FormTextFieldProps) => {
  const {
    formState: { errors, submitCount },
    control,
    register
  } = useFormContext()
  const {
    fieldState: { isTouched, error },
    field: { value }
  } = useController({ name, control })
  const success = isTouched && !error && value.length > 0

  return (
    <div className={'w-full'}>
      <Input.Root
        variants={{
          intent: success ? 'success' : 'default'
        }}
        {...register(name)}
        onBlur={e => {
          register(name).onBlur(e)
          if (customOnBlur) {
            customOnBlur(e)
          }
        }}
        label={label}
        disabled={disabled}
        type={type ?? 'text'}
      />
      {(isTouched || submitCount > 0) && error ? (
        <ErrorMessage
          errors={errors}
          name={name}
          render={({ message }) => (
            <Hint variants={{ intent: 'error' }}>{message}</Hint>
          )}
        />
      ) : null}
    </div>
  )
}
